import { apiSlice } from '@/api'

export const bannersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanners: builder.query({
      query: (buildingId) => ({
        url: `api/v2/recognitions/report/building/${buildingId}`,
        method: 'GET'
      })
    })
  })
})

export const { useGetBannersQuery } = bannersApi